import { getTableColumns } from './grid-config';
import { WEB_COMPONENT_POLICY_PANEL_DEVICE_CONTROL_RULES_TABLE } from '../../../../../../../webcomponents.constants';
import { GzPolicyUiSettingsTableWebComponent } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/dataTable';
import { customElement } from 'lit/decorators.js';
import { DeviceControlRuleItem } from '@nirvana/shared/dtos/types/policies/common';
import { GzRuleContainerWebComponent } from '../../helpers/ruleContainer';
import {
  getLabelByDeviceClassType,
  mapToDeviceControlRuleForm,
} from '../../../../utils/uiSettings/deviceControl/device-control.values';
import {
  FullPagePopupConfigs,
  GzPolicyFullPageWindow,
} from '../../../../../../common/policyPanel/uiSettings/dialogs/fullPage/GzPolicyFullPageWindow';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { ValidationResult } from '../../../../../../../ui/gzForm/formField/types/form-validator';

@customElement(WEB_COMPONENT_POLICY_PANEL_DEVICE_CONTROL_RULES_TABLE)
export class GzDeviceControlRuleGridWebComponent extends GzPolicyUiSettingsTableWebComponent<
  DeviceControlRuleItem,
  DeviceControlRuleItem
> {
  protected columns = getTableColumns.bind(this)();
  private rowIndex: number;

  protected hasReorderRowAction = false;

  private editRuleCallBack = (formValue: DeviceControlRuleItem): ValidationResult => {
    const deviceControlRuleItem: DeviceControlRuleItem = formValue;
    const cloneItems = [...this.gridComponent.items];
    cloneItems[this.rowIndex] = deviceControlRuleItem;
    this.gridComponent.items = cloneItems;
    return { valid: true };
  };

  onDevicePressed(rowIndex: number) {
    this.rowIndex = rowIndex;
    const deviceControlRuleForm = mapToDeviceControlRuleForm(this.gridComponent.items[rowIndex]);
    const gzRuleContainerWebComponent = new GzRuleContainerWebComponent(
      deviceControlRuleForm,
      this.gridComponent.items[rowIndex]
    );
    const configs: FullPagePopupConfigs = {
      bodyForm: gzRuleContainerWebComponent,
      strings: {
        title: getLabelByDeviceClassType(deviceControlRuleForm.deviceClass) + ' ' + translateFn('rule'),
        confirm: translateFn('Save#preserve state'),
        cancel: translateFn('Cancel'),
      },
      confirmCallbackFn: this.editRuleCallBack.bind(this),
    };
    new GzPolicyFullPageWindow(configs).show();
  }
}
